module.exports = __webpack_public_path__ + "static/media/icon_candado.63484ee1.svg";